import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { RequireAuth, UseActiveClient } from './components';
import { useUserStore } from './context';
import { fuseAdminRoutes } from './pages/admin';
import ApiData from './pages/api-data';
import ApiDataPage from './pages/apiData/api-data';
import { RoleTypes } from '/src/lib/models';
import {
  Dashboard,
  Login,
  Logout,
  PageNotFound,
  RequestPasswordReset,
  ResetPassword,
  Search,
  VerifyEmail,
  clientRoutes,
  equipmentRoutes,
  facilityRoutes,
  modelAuditLogRoutes,
  statementRoutes,
  userRoutes,
} from '/src/pages';

export const AppRoutes = () => {
  const location = useLocation();
  const userStore = useUserStore();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const hsq = ((window as any)._hsq = (window as any)._hsq || []);

  useEffect(() => {
    if (userStore.user) {
      hsq.push(['identify', { id: userStore.user.id, email: userStore.user.email }]);

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const dataLayer = ((window as any).dataLayer = (window as any).dataLayer || []);
      const analyticsData = {
        event: 'user_authenticated',
        user_role: userStore.user.role.name,
        user_role_id: userStore.user.role.id,
        traffic_type: userStore.user.is_internal ? 'internal' : 'external',
      };

      dataLayer.push(analyticsData);

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if (typeof (window as any).gtag === 'function') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any).gtag('config', 'G-FX79ZFCZF9', {
          traffic_type: userStore.user.is_internal ? 'internal' : 'external',
        });
      }
    }
  }, [userStore.user]);

  useEffect(() => {
    hsq.push(['setPath', location.pathname]);
    hsq.push(['trackPageView']);
  }, [location]);

  return (
    <Routes>
      {/* 404 */}
      <Route path="*" element={<PageNotFound />} />

      {...userRoutes}
      {...clientRoutes}
      {...statementRoutes}
      {...equipmentRoutes}
      {...facilityRoutes}
      {...modelAuditLogRoutes}
      {...fuseAdminRoutes}

      {/* Search Results */}
      <Route
        path="/search"
        element={
          <RequireAuth>
            <UseActiveClient>
              <Search />
            </UseActiveClient>
          </RequireAuth>
        }
      />

      {/* Login */}
      <Route path="/login" element={<Login />} />

      {/* Logout */}
      <Route path="/logout" element={<Logout />} />

      {/* Request Password Reset */}
      <Route path="/reset-password" element={<RequestPasswordReset />} />

      {/* Reset Password */}
      <Route path="/reset-password/:token" element={<ResetPassword />} />

      {/* Verify Email Address */}
      <Route path="/verify-email/:token" element={<VerifyEmail />} />

      {/* API Data */}
      <Route
        path="/api-data"
        element={
          <RequireAuth allowedRoles={[RoleTypes.FuseAdmin]}>
            <UseActiveClient>
              <ApiDataPage />
            </UseActiveClient>
          </RequireAuth>
        }
      />
      <Route
        path="/api-data-old"
        element={
          <RequireAuth allowedRoles={[RoleTypes.FuseAdmin]}>
            <ApiData />
          </RequireAuth>
        }
      />

      {/* Dashboard */}
      <Route
        path="/"
        element={
          <RequireAuth>
            <UseActiveClient>
              <Dashboard />
            </UseActiveClient>
          </RequireAuth>
        }
      />
    </Routes>
  );
};
